export default {
	mounted(){
		app.store.commit('communication_ui/config/set_smsApiUrl','https://staging.microservices.kizansolutions.com/api/sms');
	}
}
